// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Libraries
import { withTranslation } from 'shared/utils/withTranslation'

// Components
import BOverdue from 'store/v2/react/scenes/cart/blocks/Overdue'

// Shared

/**
 * Overdue notification
 *
 * @example
 *   <Overdue show={Boolean} websiteURL={String} />
 */

export class Overdue extends Component {
  static displayName = 'Overdue'

  static propTypes = {
    show: PropTypes.bool
  }

  render = () => {
    return this.props.show && (
      <BOverdue>
        <i className="fas fa-exclamation-triangle" />
        {this.props.t('user.checkout.dates_in_past')}
      </BOverdue>
    )
  }
}

export default withTranslation('user')(Overdue)
